import { addToChainBefore } from "@insite/client-framework/HandlerCreator";
import { chain, ResetData } from "@insite/client-framework/Store/Pages/Cart/Handlers/ClearCurrentCart";
import { clearSelectedCarrier } from "@solveindustrial/Utilities/sessionStorageUtils";

addToChainBefore(chain, ResetData, () => {
    // we clear the session storage for the selectedCarrier if it exists
    clearSelectedCarrier();
});
